import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { set_user } from "../../../../redux/actions/AuthAction";
import { set_store } from "../../../../redux/actions/CreateStoreAction";
import { set_page_state } from "../../../../redux/actions/PageStateAction";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { signUp } from "../../../../jtoker";
import $ from "jquery";

import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import * as Yup from "yup";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import { MdVisibility } from "react-icons/md";
import { MdVisibilityOff } from "react-icons/md";
import { Redirect, useLocation } from "react-router-dom";

const logInSchema = Yup.object().shape({
  email: Yup.string().email().required("Required"),
  contact_number: Yup.string().required("Required"),
  first_name_en: Yup.string().required("Required"),
  last_name_en: Yup.string().required("Required"),
  password: Yup.string()
    .required("Required")
    .min(6, "should be 6 chars minimum")
    .max(32, "should be 32 chars maximum"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Passwords must match"),
});

const LoginForm = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const unique_code = queryParams.get("unique_code");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [redirectToLogin, setRedirectToLogin] = useState(false);
  const [loading, setLoading] = useState(true);
  const values = {
    email: "",
    contact_number: props.store?.contact_number || "",
    first_name_en: props.store?.first_name_en || "",
    first_name_ar: props.store?.first_name_ar || "",
    last_name_en: props.store?.last_name_en || "",
    last_name_ar: props.store?.last_name_ar || "",
    password: "",
    confirm_password: "",
  };

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const SignUp = (values) => {
    setLoading(false);
    setRedirectToLogin(false);
    signUp({
      email: values?.email,
      contact_number: values?.contact_number,
      first_name_en: values?.first_name_en,
      first_name_ar: values?.first_name_ar
        ? values?.first_name_ar
        : values?.first_name_en,
      last_name_en: values?.last_name_en,
      last_name_ar: values?.last_name_ar
        ? values?.last_name_ar
        : values?.last_name_en,
      password: values?.password,
      confirm_password: values?.confirm_password,
      unique_code: unique_code
    })
      .then(() => {
        localStorage.setItem(
          "access_token",
          $.auth.retrieveData("authHeaders")["access-token"]
        );
        localStorage.setItem(
          "client",
          $.auth.retrieveData("authHeaders").client
        );
        localStorage.setItem("uid", $.auth.retrieveData("authHeaders").uid);
        props.set_user({ isSignedIn: true, user: $.auth.user });
        message = "Successfully Sign Up";
        setLoading(true);
        showSuccess();
        props.set_page_state({ pageState: { id: 2 } });
      })
      .fail((error) => {
        setLoading(true);
        if (!error.data.errors) {
          message = "Network Error!";
          showError();
        } else if (
          error.data?.errors?.email[0].toLowerCase() ===
          "has already been taken"
        ) {
          message = `${error?.data?.errors.full_messages[0]}. Login to continue`;
          showError();
          setRedirectToLogin(true);
        } else {
          message = error?.data?.errors.full_messages[0];
          showError();
        }
      });
  };

  return (
    <Fragment>
      <Formik
        initialValues={values}
        validationSchema={logInSchema}
        isValidating={true}
        onSubmit={(values) => SignUp(values)}
      >
        {() => {
          return (
            <Form className="form mx-auto">
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="email"
                type="email"
                label="Email"
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="contact_number"
                type="number"
                label="Contact Number"
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="first_name_en"
                type="text"
                label="First Name"
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="last_name_en"
                type="text"
                label="Last Name"
                disabled={false}
              />
              <Field
                style={{
                  width: "100%",
                  marginBottom: "60px",
                }}
                component={TextField}
                name="first_name_ar"
                type="text"
                label="الاسم الاول"
                className="arabic"
                disabled={false}
              />
              <Field
                style={{
                  width: "100%",
                  marginBottom: "60px",
                }}
                component={TextField}
                name="last_name_ar"
                type="text"
                label="الكنية"
                className="arabic"
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="password"
                type={showPassword ? "text" : "password"}
                label="Password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={false}
              />
              <Field
                style={{ width: "100%", marginBottom: "60px" }}
                component={TextField}
                name="confirm_password"
                type={showConfirmPassword ? "text" : "password"}
                label="Confirm Password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <MdVisibility />
                        ) : (
                          <MdVisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={false}
              />
              <br />
              <button
                key={72223}
                type="submit"
                className="next-button d-flex justify-content-center align-items-center"
                disabled={!loading}
              >
                {loading ? "Next" : <ClipLoader color="#000" size={17} />}
              </button>
            </Form>
          );
        }}
      </Formik>
      {redirectToLogin && <Redirect to={{ pathname: "/" }} />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    pageState: state.pageState.pageState,
    store: state.store.store,
  };
};

const mapDispatchTopProps = { set_user, set_page_state, set_store };

export default connect(mapStateToProps, mapDispatchTopProps)(LoginForm);
